import React from 'react'
import { LockedSchoolsIds } from '../../utility/utils'
import { PlainLink } from 'app/components/RouteLink'

const SchoolHeader = ({
  data,
}: {
  data: {
    district: {
      id: number
      name: string
    }
    id: number
    name: string
    address: string
    city: string
    state: string
    county: string
    zip_code: string
    country: string
    is_verified: boolean
    created_at: string
    deleted_at?: string
  }
}) => {
  return (
    <>
      {LockedSchoolsIds.includes(data.id) && (
        <p>
          <b>This school is locked, no changes should be made to this school</b>
        </p>
      )}
      <p>
        Name:<b> {data.name} </b>
      </p>
      <p>
        ID: <b> {data.id} </b>
      </p>
      <p>
        Address:<b> {data.address} </b>
      </p>
      <p>
        ZIP code:<b> {data.zip_code} </b>
      </p>
      <p>
        City: <b> {data.city} </b>
      </p>
      <p>
        County:<b> {data.county} </b>
      </p>
      <p>
        State: <b> {data.state} </b>
      </p>
      <p>
        Country:<b> {data.country} </b>
      </p>
      <p>
        Is verified:<b> {data.is_verified ? 'true' : 'false'} </b>
      </p>
      <p>
        Created At: <b> {data.created_at} </b>
      </p>
      {data.deleted_at && (
        <p>
          Deleted At: <b> {data.deleted_at} </b>
        </p>
      )}
      {data.district && (
        <p>
          <span>District: </span>
          <span>
            <PlainLink
              to={`/districts/${data.district.id}/show`}
              className="link"
            >
              {data.district.name}
            </PlainLink>
          </span>
        </p>
      )}
    </>
  )
}

export default SchoolHeader
